import React, { useState, useMemo } from 'react';
import { BotType } from '@/Data/Bot';
import './FriendCard.scss';

interface FriendCardProps {
    friend: BotType;
    onClick?: () => void;
    selected?: boolean;
    staticMode?: boolean;
}

const FriendCard: React.FC<FriendCardProps> = ({ friend, onClick, selected = false, staticMode = false }) => {
    const [showDescription, setShowDescription] = useState(false);

    // Combine tags for display
    const tags = useMemo(() => {
        const allTags = [...(friend.personality || []), ...(friend.hobby || []), ...(friend.tags || [])];
        const unique = [...new Set(allTags)];
        return unique.sort(() => Math.random() - 0.5).slice(0, 3);
    }, [friend]);

    const handleClick = () => {
        if (staticMode) {
            setShowDescription(prev => !prev);
        }
        if (onClick) {
            onClick();
        }
    };

    return (
        <div className={`FriendCard ${selected ? 'Selected' : ''}`} onClick={handleClick}>
            {/* Thumbnail */}
            <img src={friend.thumbnail} alt={friend.name} className="Thumbnail" />

            {/* Gradient overlay */}
            <div className="GradientOverlay" />

            {/* Description backdrop when expanded */}
            {showDescription && <div className="DescriptionBackdrop" />}

            {/* Profile info */}
            <div className="Profile">
                <div className="NameRow">
                    <span className="Name">{friend.name}, {friend.age}</span>
                    <span className="OnlineDot" />
                </div>
                <div className="Origin">{friend.origin}</div>

                {/* Description (expandable in static mode) */}
                <div className={`Description ${showDescription ? 'Expanded' : ''}`}>
                    {friend.description}
                </div>

                {/* Tags */}
                <div className="TagsRow">
                    {tags.map(tag => (
                        <span key={tag} className="Tag">{tag}</span>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FriendCard;
